interface EPSG {
    Name: string;
    Longitude: number;
    Latitude: number;
    Code: number;
    LongitudeActual?: number;
    LatitudeActual?: number;
}

export const EPSGList: EPSG[] = [
    { Name: "V?nh Phúc", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "TP. Hà N?i", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "Hà Nam", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "Ninh Bình", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "Thanh Hoá", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "??ng Tháp", Longitude: 105, Latitude: 10.5, LongitudeActual: 105.63333, LatitudeActual: 10.58333, Code: 5897 },
    { Name: "TP.C?n Th?", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "H?u Giang", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "B?c Liêu", Longitude: 105, Latitude: 10.5, Code: 5897 },
    { Name: "Qu?ng Ninh", Longitude: 107.75, Latitude: 10.5, Code: 5899 },
    { Name: "TP.?à N?ng", Longitude: 107.75, Latitude: 10.5, Code: 5899 },
    { Name: "Qu?ng Nam", Longitude: 107.75, Latitude: 10.5, Code: 5899 },
    { Name: "Lâm ??ng", Longitude: 107.75, Latitude: 10.5, Code: 5899 },
    { Name: "??ng Nai", Longitude: 107.75, Latitude: 10.5, Code: 5899 },
    { Name: "Bà R?a – V?ng Tàu", Longitude: 107.75, Latitude: 10.5, LongitudeActual: 107.129407, LatitudeActual: 10.382735, Code: 5899 },
    { Name: "Lai Châu", Longitude: 103, Latitude: 10.5, Code: 9205 },
    { Name: "?i?n Biên", Longitude: 103, Latitude: 10.5, Code: 9205 },
    { Name: "S?n La", Longitude: 104, Latitude: 10.5, Code: 9206 },
    { Name: "Kiên Giang", Longitude: 104.5, Latitude: 10.5, Code: 9207 },
    { Name: "Cà Mau", Longitude: 104.5, Latitude: 10.5, Code: 9207 },
    { Name: "Lào Cai", Longitude: 104.75, Latitude: 10.5, Code: 9208 },
    { Name: "Yên Bái", Longitude: 104.75, Latitude: 10.5, Code: 9208 },
    { Name: "Phú Th?", Longitude: 104.75, Latitude: 10.5, Code: 9208 },
    { Name: "Ngh? An", Longitude: 104.75, Latitude: 10.5, Code: 9208 },
    { Name: "An Giang", Longitude: 104.75, Latitude: 10.5, Code: 9208 },
    { Name: "Hà Giang", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "B?c Ninh", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "H?i D??ng", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "H?ng Yên", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "Nam ??nh", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "Thái Bình", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "Hà T?nh", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "Tây Ninh", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "V?nh Long", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "Trà Vinh", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "Sóc Tr?ng", Longitude: 105.5, Latitude: 10.5, Code: 9209 },
    { Name: "Cao B?ng", Longitude: 105.75, Latitude: 10.5, Code: 9210 },
    { Name: "TP.H?i Phòng", Longitude: 105.75, Latitude: 10.5, Code: 9210 },
    { Name: "Bình D??ng", Longitude: 105.75, Latitude: 10.5, Code: 9210 },
    { Name: "Long An", Longitude: 105.75, Latitude: 10.5, Code: 9210 },
    { Name: "Ti?n Giang", Longitude: 105.75, Latitude: 10.5, Code: 9210 },
    { Name: "B?n Tre", Longitude: 105.75, Latitude: 10.5, Code: 9210 },
    { Name: "TP.H? Chí Minh", Longitude: 105.75, Latitude: 10.5, LongitudeActual: 106.660172, LatitudeActual: 10.762622, Code: 9210 },
    { Name: "Tuyên Quang", Longitude: 106, Latitude: 10.5, Code: 9211 },
    { Name: "Hòa Bình", Longitude: 106, Latitude: 10.5, Code: 9211 },
    { Name: "Qu?ng Bình", Longitude: 106, Latitude: 10.5, Code: 9211 },
    { Name: "Qu?ng Tr?", Longitude: 106.25, Latitude: 10.5, Code: 9212 },
    { Name: "Bình Ph??c", Longitude: 106.25, Latitude: 10.5, Code: 9212 },
    { Name: "B?c C?n", Longitude: 106.5, Latitude: 10.5, Code: 9213 },
    { Name: "Thái Nguyên", Longitude: 106.5, Latitude: 10.5, Code: 9213 },
    { Name: "B?c Giang", Longitude: 107, Latitude: 10.5, Code: 9214 },
    { Name: "Th?a Thiên – Hu?", Longitude: 107, Latitude: 10.5, Code: 9214 },
    { Name: "L?ng S?n", Longitude: 107.25, Latitude: 10.5, Code: 9215 },
    { Name: "Kon Tum", Longitude: 107.5, Latitude: 10.5, Code: 9216 },
    { Name: "Bình ??nh", Longitude: 108.25, Latitude: 10.5, Code: 9217 },
    { Name: "Khánh Hoà", Longitude: 108.25, Latitude: 10.5, Code: 9217 },
    { Name: "Ninh Thu?n", Longitude: 108.25, Latitude: 10.5, Code: 9217 },
    { Name: "Gia Lai", Longitude: 108.5, Latitude: 10.5, Code: 9218 },
    { Name: "??k L?k", Longitude: 108.5, Latitude: 10.5, Code: 9218 },
    { Name: "??c Nông", Longitude: 108.5, Latitude: 10.5, Code: 9218 },
    { Name: "Phú Yên", Longitude: 108.5, Latitude: 10.5, Code: 9218 },
    { Name: "Bình Thu?n", Longitude: 108.5, Latitude: 10.5, Code: 9218 },
    { Name: "Qu?ng Ngãi", Longitude: 108, Latitude: 10.5, Code: 5898 }
];

export const getAllEPSG = (): EPSG[] => {
    return EPSGList;
}



export const getCode = (longitude: number, latitude: number) => {
    // Hàm tính khoảng cách giữa hai tọa độ
    const calculateDistance = (lon1: number, lat1: number, lon2: number, lat2: number): number => {
        return Math.sqrt(Math.pow(lon1 - lon2, 2) + Math.pow(lat1 - lat2, 2)); // Công thức Euclidean
    };

    let nearest: EPSG | null = null;
    let minDistance = Infinity;

    // Bước 1: Tìm mục gần nhất chỉ trong các mục có LongitudeActual và LatitudeActual
    EPSGList.forEach((epsg) => {
        if (epsg.LongitudeActual !== undefined && epsg.LatitudeActual !== undefined) {
            const distance = calculateDistance(longitude, latitude, epsg.LongitudeActual, epsg.LatitudeActual);
            if (distance < minDistance) {
                minDistance = distance;
                nearest = epsg; // Lưu mục gần nhất
            }
        }
    });

    // Bước 2: Nếu không tìm thấy trong bước 1, tìm trong toàn bộ danh sách
    if (nearest === null) {
        minDistance = Infinity; // Reset khoảng cách nhỏ nhất
        EPSGList.forEach((epsg) => {
            const distance = calculateDistance(longitude, latitude, epsg.Longitude, epsg.Latitude);
            if (distance < minDistance) {
                minDistance = distance;
                nearest = epsg; // Lưu mục gần nhất
            }
        });
    }

    // Trả về Code của mục gần nhất nếu tìm thấy, hoặc Code của mục đầu tiên nếu không có mục phù hợp
    return nearest ? nearest: EPSGList[0];
};
